/* Block - Link Banner.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-link-banner.scss";

jQuery(document).ready(function($) {
    function adjustLinkSeperatorClasses() {
        const $content = $('.link-banner-container').children();
        // Reset the 'last-in-line' class for all elements
        $content.removeClass('last-in-line');
        const lines = {}; // Object to hold arrays of elements by their top offset
        // Iterate through each element in $content
        $content.each(function() {
            const $currentItem = $(this);
            const currentTopOffset = $currentItem.offset().top;
            // Initialize the array for this line if it doesn't exist
            if (!lines[currentTopOffset]) {
                lines[currentTopOffset] = [];
            }
            // Add the current item to its respective line
            lines[currentTopOffset].push($currentItem);
        });
        // Iterate through each line
        $.each(lines, function(offset, items) {
            // Find the last element in the current line
            const $lastItem = items[items.length - 1];
            // Add a class to the last element
            $lastItem.addClass('last-in-line');
        });
    }

    // Call on document ready
    adjustLinkSeperatorClasses();

    // Call on window resize
    $(window).resize(adjustLinkSeperatorClasses);
});
